var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.144 1.08673H4.69954C3.61592 1.08812 2.57706 1.54995 1.81082 2.37092C1.04458 3.19188 0.613542 4.30496 0.612244 5.46598L0.612244 15.9762C0.613542 17.1372 1.04458 18.2503 1.81082 19.0712C2.57706 19.8922 3.61592 20.354 4.69954 20.3554H16.144C17.2276 20.354 18.2665 19.8922 19.0327 19.0712C19.799 18.2503 20.23 17.1372 20.2313 15.9762V5.46598C20.23 4.30496 19.799 3.19188 19.0327 2.37092C18.2665 1.54995 17.2276 1.08812 16.144 1.08673ZM4.69954 2.83843H16.144C16.6335 2.83946 17.1115 2.99741 17.5165 3.29195C17.9215 3.58649 18.2349 4.00414 18.4165 4.49116L12.1564 11.1993C11.6957 11.6909 11.072 11.9669 10.4218 11.9669C9.77155 11.9669 9.14781 11.6909 8.68712 11.1993L2.42701 4.49116C2.6086 4.00414 2.92207 3.58649 3.32707 3.29195C3.73207 2.99741 4.21006 2.83946 4.69954 2.83843ZM16.144 18.6037H4.69954C4.04913 18.6037 3.42536 18.3269 2.96545 17.8341C2.50554 17.3414 2.24716 16.6731 2.24716 15.9762V6.77975L7.53123 12.4377C8.29852 13.2578 9.33803 13.7183 10.4218 13.7183C11.5055 13.7183 12.545 13.2578 13.3123 12.4377L18.5964 6.77975V15.9762C18.5964 16.6731 18.338 17.3414 17.8781 17.8341C17.4182 18.3269 16.7944 18.6037 16.144 18.6037Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.619,
    height: 21.0204,
    fill: "white",
    transform: "translate(0.612244 0.210907)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIconWhite);
export default __webpack_public_path__ + "static/media/mail_icon_white.611fc7a48708dfa7f678f144b0c518e8.svg";
export { ForwardRef as ReactComponent };